// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"VIP_List__listWrapper"};